'use strict';

/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/call-bind-apply-helpers/reflectApply.js
// module id = ../../../../call-bind-apply-helpers/reflectApply.js
// module chunks = 5